import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { apiList, getApiUrl } from 'src/app/core/Constants/apiList';
import { USER_TYPE } from 'src/app/core/Constants/static';
import { UserDetails } from 'src/app/core/Models/interfaces/user-details';
import { UserService } from 'src/app/core/Services/user.service';
import { ProvPayerApiService } from './prov-payer-api.service';

@Injectable({
  providedIn: 'root'
})
export class ProvPayerService {

  public isThirdParyOpened$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  user?: UserDetails
  constructor(private provPayerApiService: ProvPayerApiService,
    private http: HttpClient,
    private userSrvice: UserService) {
    this.user = userSrvice.getUserInfo()?.userDetails;
  }

  getEditPayerDetails(id: any) {
    let endpoint = getApiUrl(apiList.editPayer.getEditpayerDetails, null, { id });
    return this.http.get<any>(endpoint);
  }
  saveEditPayerDetails(id: any, payLoad: any) {
    let endpoint = getApiUrl(apiList.editPayer.saveEditPayerDetails, null, { id });
    return this.http.put<any>(endpoint, payLoad)
  }
  
  getDrugList(payload: any, id: any) {
    let endpoint = getApiUrl(apiList.drugList.getDrugList, payload, { id });
    return this.http.get<any>(endpoint)
  }

  // for master drug details -admin
  getClientDrugDetails(payload: any, id: number) {
    let endpoint = getApiUrl(apiList.drugList.getClientDrugDetails, payload, { id: 1 });
    return this.http.get<any>(endpoint);
  }

  // for  drug details -payer
  getPayerDrugDetails(payload: any, id: any) {
    (this.user?.userType === USER_TYPE.payer)
    let endpoint = getApiUrl(apiList.drugList.getPayerDrugDetails, payload, { id: id });
    return this.http.get<any>(endpoint)
  }

  // for  drug details -provider
  // getProviderDrugDetails(payload: any, id: number) {
  //   let endpoint = getApiUrl(apiList.drugList.getProviderDrugDetails, payload, { id: id });
  //   return this.http.get<any>(endpoint)
  // }
  
  // for prefered drug details -admin
  // getDrugDetails(payload:any,id:any){
  //   let endpoint = getApiUrl(apiList.drugList.getdrugDetails,payload,{id:id});
  //   return this.http.get<any>(endpoint);
  // }

}
